import { FeatureFlag, getEnabledFeatures } from "@/js/api/features";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

/**
 * Query to get the enabled feature flags for a given appliance ID.
 *
 * @example
 * ```ts
 * const featureFlagsQuery = useFeatureFlagsQuery("example-appliance-id");
 * // Check if the feature flag is enabled
 * featureFlagsQuery.data.includes("FEATURE_FLAG_NAME");
 * ```
 * @returns A query result with the enabled feature flags.
 */
export function useFeatureFlagsQuery(applianceId: string): UseQueryResult<FeatureFlag[]> {
	return useQuery({
		queryKey: ["enabledFeatureFlags", applianceId],
		queryFn: async () => {
			const res = await getEnabledFeatures(applianceId);
			return res.enabledFeatures;
		},
		initialData: [],
	});
}
